import { render, staticRenderFns } from "./BetaTag.vue?vue&type=template&id=31f591a8&"
import script from "./BetaTag.vue?vue&type=script&lang=js&"
export * from "./BetaTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports